
    import './styles.scoped.css';
    export default {
  "box": "awsui_box_18wu0_nrld8_24",
  "p-variant": "awsui_p-variant_18wu0_nrld8_24",
  "color-default": "awsui_color-default_18wu0_nrld8_24",
  "b-variant": "awsui_b-variant_18wu0_nrld8_24",
  "strong-variant": "awsui_strong-variant_18wu0_nrld8_24",
  "code-variant": "awsui_code-variant_18wu0_nrld8_24",
  "pre-variant": "awsui_pre-variant_18wu0_nrld8_24",
  "samp-variant": "awsui_samp-variant_18wu0_nrld8_24",
  "h1-variant": "awsui_h1-variant_18wu0_nrld8_28",
  "h2-variant": "awsui_h2-variant_18wu0_nrld8_28",
  "h3-variant": "awsui_h3-variant_18wu0_nrld8_28",
  "h4-variant": "awsui_h4-variant_18wu0_nrld8_28",
  "h5-variant": "awsui_h5-variant_18wu0_nrld8_28",
  "small-variant": "awsui_small-variant_18wu0_nrld8_32",
  "a-variant": "awsui_a-variant_18wu0_nrld8_36",
  "font-size-default": "awsui_font-size-default_18wu0_nrld8_40",
  "font-weight-default": "awsui_font-weight-default_18wu0_nrld8_81",
  "key-label-variant": "awsui_key-label-variant_18wu0_nrld8_123",
  "gen-ai-label-variant": "awsui_gen-ai-label-variant_18wu0_nrld8_130",
  "value-large-variant": "awsui_value-large-variant_18wu0_nrld8_137",
  "inline-code-variant": "awsui_inline-code-variant_18wu0_nrld8_147",
  "font-weight-heavy": "awsui_font-weight-heavy_18wu0_nrld8_161",
  "color-inverted": "awsui_color-inverted_18wu0_nrld8_166",
  "color-text-label": "awsui_color-text-label_18wu0_nrld8_169",
  "color-text-body-secondary": "awsui_color-text-body-secondary_18wu0_nrld8_172",
  "color-text-status-error": "awsui_color-text-status-error_18wu0_nrld8_175",
  "color-text-status-success": "awsui_color-text-status-success_18wu0_nrld8_178",
  "color-text-status-info": "awsui_color-text-status-info_18wu0_nrld8_181",
  "color-text-status-inactive": "awsui_color-text-status-inactive_18wu0_nrld8_184",
  "color-text-status-warning": "awsui_color-text-status-warning_18wu0_nrld8_187",
  "color-inherit": "awsui_color-inherit_18wu0_nrld8_190",
  "font-size-body-s": "awsui_font-size-body-s_18wu0_nrld8_193",
  "font-size-body-m": "awsui_font-size-body-m_18wu0_nrld8_198",
  "font-size-heading-xs": "awsui_font-size-heading-xs_18wu0_nrld8_202",
  "font-size-heading-s": "awsui_font-size-heading-s_18wu0_nrld8_207",
  "font-size-heading-m": "awsui_font-size-heading-m_18wu0_nrld8_212",
  "font-size-heading-l": "awsui_font-size-heading-l_18wu0_nrld8_217",
  "font-size-heading-xl": "awsui_font-size-heading-xl_18wu0_nrld8_222",
  "font-size-display-l": "awsui_font-size-display-l_18wu0_nrld8_227",
  "font-size-display-xl": "awsui_font-size-display-xl_18wu0_nrld8_232",
  "font-weight-light": "awsui_font-weight-light_18wu0_nrld8_237",
  "font-weight-normal": "awsui_font-weight-normal_18wu0_nrld8_240",
  "font-weight-bold": "awsui_font-weight-bold_18wu0_nrld8_243",
  "t-left": "awsui_t-left_18wu0_nrld8_250",
  "t-right": "awsui_t-right_18wu0_nrld8_254",
  "t-center": "awsui_t-center_18wu0_nrld8_258",
  "p-n": "awsui_p-n_18wu0_nrld8_267",
  "p-top-n": "awsui_p-top-n_18wu0_nrld8_272",
  "p-vertical-n": "awsui_p-vertical-n_18wu0_nrld8_273",
  "p-right-n": "awsui_p-right-n_18wu0_nrld8_277",
  "p-horizontal-n": "awsui_p-horizontal-n_18wu0_nrld8_278",
  "p-bottom-n": "awsui_p-bottom-n_18wu0_nrld8_282",
  "p-left-n": "awsui_p-left-n_18wu0_nrld8_287",
  "p-xxxs": "awsui_p-xxxs_18wu0_nrld8_292",
  "p-top-xxxs": "awsui_p-top-xxxs_18wu0_nrld8_297",
  "p-vertical-xxxs": "awsui_p-vertical-xxxs_18wu0_nrld8_298",
  "p-right-xxxs": "awsui_p-right-xxxs_18wu0_nrld8_302",
  "p-horizontal-xxxs": "awsui_p-horizontal-xxxs_18wu0_nrld8_303",
  "p-bottom-xxxs": "awsui_p-bottom-xxxs_18wu0_nrld8_307",
  "p-left-xxxs": "awsui_p-left-xxxs_18wu0_nrld8_312",
  "p-xxs": "awsui_p-xxs_18wu0_nrld8_317",
  "p-top-xxs": "awsui_p-top-xxs_18wu0_nrld8_322",
  "p-vertical-xxs": "awsui_p-vertical-xxs_18wu0_nrld8_323",
  "p-right-xxs": "awsui_p-right-xxs_18wu0_nrld8_327",
  "p-horizontal-xxs": "awsui_p-horizontal-xxs_18wu0_nrld8_328",
  "p-bottom-xxs": "awsui_p-bottom-xxs_18wu0_nrld8_332",
  "p-left-xxs": "awsui_p-left-xxs_18wu0_nrld8_337",
  "p-xs": "awsui_p-xs_18wu0_nrld8_342",
  "p-top-xs": "awsui_p-top-xs_18wu0_nrld8_347",
  "p-vertical-xs": "awsui_p-vertical-xs_18wu0_nrld8_348",
  "p-right-xs": "awsui_p-right-xs_18wu0_nrld8_352",
  "p-horizontal-xs": "awsui_p-horizontal-xs_18wu0_nrld8_353",
  "p-bottom-xs": "awsui_p-bottom-xs_18wu0_nrld8_357",
  "p-left-xs": "awsui_p-left-xs_18wu0_nrld8_362",
  "p-s": "awsui_p-s_18wu0_nrld8_367",
  "p-top-s": "awsui_p-top-s_18wu0_nrld8_372",
  "p-vertical-s": "awsui_p-vertical-s_18wu0_nrld8_373",
  "p-right-s": "awsui_p-right-s_18wu0_nrld8_377",
  "p-horizontal-s": "awsui_p-horizontal-s_18wu0_nrld8_378",
  "p-bottom-s": "awsui_p-bottom-s_18wu0_nrld8_382",
  "p-left-s": "awsui_p-left-s_18wu0_nrld8_387",
  "p-m": "awsui_p-m_18wu0_nrld8_392",
  "p-top-m": "awsui_p-top-m_18wu0_nrld8_397",
  "p-vertical-m": "awsui_p-vertical-m_18wu0_nrld8_398",
  "p-right-m": "awsui_p-right-m_18wu0_nrld8_402",
  "p-horizontal-m": "awsui_p-horizontal-m_18wu0_nrld8_403",
  "p-bottom-m": "awsui_p-bottom-m_18wu0_nrld8_407",
  "p-left-m": "awsui_p-left-m_18wu0_nrld8_412",
  "p-l": "awsui_p-l_18wu0_nrld8_287",
  "p-top-l": "awsui_p-top-l_18wu0_nrld8_422",
  "p-vertical-l": "awsui_p-vertical-l_18wu0_nrld8_423",
  "p-right-l": "awsui_p-right-l_18wu0_nrld8_427",
  "p-horizontal-l": "awsui_p-horizontal-l_18wu0_nrld8_428",
  "p-bottom-l": "awsui_p-bottom-l_18wu0_nrld8_432",
  "p-left-l": "awsui_p-left-l_18wu0_nrld8_437",
  "p-xl": "awsui_p-xl_18wu0_nrld8_442",
  "p-top-xl": "awsui_p-top-xl_18wu0_nrld8_447",
  "p-vertical-xl": "awsui_p-vertical-xl_18wu0_nrld8_448",
  "p-right-xl": "awsui_p-right-xl_18wu0_nrld8_452",
  "p-horizontal-xl": "awsui_p-horizontal-xl_18wu0_nrld8_453",
  "p-bottom-xl": "awsui_p-bottom-xl_18wu0_nrld8_457",
  "p-left-xl": "awsui_p-left-xl_18wu0_nrld8_462",
  "p-xxl": "awsui_p-xxl_18wu0_nrld8_467",
  "p-top-xxl": "awsui_p-top-xxl_18wu0_nrld8_472",
  "p-vertical-xxl": "awsui_p-vertical-xxl_18wu0_nrld8_473",
  "p-right-xxl": "awsui_p-right-xxl_18wu0_nrld8_477",
  "p-horizontal-xxl": "awsui_p-horizontal-xxl_18wu0_nrld8_478",
  "p-bottom-xxl": "awsui_p-bottom-xxl_18wu0_nrld8_482",
  "p-left-xxl": "awsui_p-left-xxl_18wu0_nrld8_487",
  "p-xxxl": "awsui_p-xxxl_18wu0_nrld8_492",
  "p-top-xxxl": "awsui_p-top-xxxl_18wu0_nrld8_497",
  "p-vertical-xxxl": "awsui_p-vertical-xxxl_18wu0_nrld8_498",
  "p-right-xxxl": "awsui_p-right-xxxl_18wu0_nrld8_502",
  "p-horizontal-xxxl": "awsui_p-horizontal-xxxl_18wu0_nrld8_503",
  "p-bottom-xxxl": "awsui_p-bottom-xxxl_18wu0_nrld8_507",
  "p-left-xxxl": "awsui_p-left-xxxl_18wu0_nrld8_512",
  "m-n": "awsui_m-n_18wu0_nrld8_517",
  "m-top-n": "awsui_m-top-n_18wu0_nrld8_522",
  "m-vertical-n": "awsui_m-vertical-n_18wu0_nrld8_523",
  "m-right-n": "awsui_m-right-n_18wu0_nrld8_527",
  "m-horizontal-n": "awsui_m-horizontal-n_18wu0_nrld8_528",
  "m-bottom-n": "awsui_m-bottom-n_18wu0_nrld8_532",
  "m-left-n": "awsui_m-left-n_18wu0_nrld8_537",
  "m-xxxs": "awsui_m-xxxs_18wu0_nrld8_542",
  "m-top-xxxs": "awsui_m-top-xxxs_18wu0_nrld8_547",
  "m-vertical-xxxs": "awsui_m-vertical-xxxs_18wu0_nrld8_548",
  "m-right-xxxs": "awsui_m-right-xxxs_18wu0_nrld8_552",
  "m-horizontal-xxxs": "awsui_m-horizontal-xxxs_18wu0_nrld8_553",
  "m-bottom-xxxs": "awsui_m-bottom-xxxs_18wu0_nrld8_557",
  "m-left-xxxs": "awsui_m-left-xxxs_18wu0_nrld8_562",
  "m-xxs": "awsui_m-xxs_18wu0_nrld8_567",
  "m-top-xxs": "awsui_m-top-xxs_18wu0_nrld8_572",
  "m-vertical-xxs": "awsui_m-vertical-xxs_18wu0_nrld8_573",
  "m-right-xxs": "awsui_m-right-xxs_18wu0_nrld8_577",
  "m-horizontal-xxs": "awsui_m-horizontal-xxs_18wu0_nrld8_578",
  "m-bottom-xxs": "awsui_m-bottom-xxs_18wu0_nrld8_582",
  "m-left-xxs": "awsui_m-left-xxs_18wu0_nrld8_587",
  "m-xs": "awsui_m-xs_18wu0_nrld8_592",
  "m-top-xs": "awsui_m-top-xs_18wu0_nrld8_597",
  "m-vertical-xs": "awsui_m-vertical-xs_18wu0_nrld8_598",
  "m-right-xs": "awsui_m-right-xs_18wu0_nrld8_602",
  "m-horizontal-xs": "awsui_m-horizontal-xs_18wu0_nrld8_603",
  "m-bottom-xs": "awsui_m-bottom-xs_18wu0_nrld8_607",
  "m-left-xs": "awsui_m-left-xs_18wu0_nrld8_612",
  "m-s": "awsui_m-s_18wu0_nrld8_617",
  "m-top-s": "awsui_m-top-s_18wu0_nrld8_622",
  "m-vertical-s": "awsui_m-vertical-s_18wu0_nrld8_623",
  "m-right-s": "awsui_m-right-s_18wu0_nrld8_627",
  "m-horizontal-s": "awsui_m-horizontal-s_18wu0_nrld8_628",
  "m-bottom-s": "awsui_m-bottom-s_18wu0_nrld8_632",
  "m-left-s": "awsui_m-left-s_18wu0_nrld8_637",
  "m-m": "awsui_m-m_18wu0_nrld8_642",
  "m-top-m": "awsui_m-top-m_18wu0_nrld8_647",
  "m-vertical-m": "awsui_m-vertical-m_18wu0_nrld8_648",
  "m-right-m": "awsui_m-right-m_18wu0_nrld8_652",
  "m-horizontal-m": "awsui_m-horizontal-m_18wu0_nrld8_653",
  "m-bottom-m": "awsui_m-bottom-m_18wu0_nrld8_657",
  "m-left-m": "awsui_m-left-m_18wu0_nrld8_662",
  "m-l": "awsui_m-l_18wu0_nrld8_537",
  "m-top-l": "awsui_m-top-l_18wu0_nrld8_672",
  "m-vertical-l": "awsui_m-vertical-l_18wu0_nrld8_673",
  "m-right-l": "awsui_m-right-l_18wu0_nrld8_677",
  "m-horizontal-l": "awsui_m-horizontal-l_18wu0_nrld8_678",
  "m-bottom-l": "awsui_m-bottom-l_18wu0_nrld8_682",
  "m-left-l": "awsui_m-left-l_18wu0_nrld8_687",
  "m-xl": "awsui_m-xl_18wu0_nrld8_692",
  "m-top-xl": "awsui_m-top-xl_18wu0_nrld8_697",
  "m-vertical-xl": "awsui_m-vertical-xl_18wu0_nrld8_698",
  "m-right-xl": "awsui_m-right-xl_18wu0_nrld8_702",
  "m-horizontal-xl": "awsui_m-horizontal-xl_18wu0_nrld8_703",
  "m-bottom-xl": "awsui_m-bottom-xl_18wu0_nrld8_707",
  "m-left-xl": "awsui_m-left-xl_18wu0_nrld8_712",
  "m-xxl": "awsui_m-xxl_18wu0_nrld8_717",
  "m-top-xxl": "awsui_m-top-xxl_18wu0_nrld8_722",
  "m-vertical-xxl": "awsui_m-vertical-xxl_18wu0_nrld8_723",
  "m-right-xxl": "awsui_m-right-xxl_18wu0_nrld8_727",
  "m-horizontal-xxl": "awsui_m-horizontal-xxl_18wu0_nrld8_728",
  "m-bottom-xxl": "awsui_m-bottom-xxl_18wu0_nrld8_732",
  "m-left-xxl": "awsui_m-left-xxl_18wu0_nrld8_737",
  "m-xxxl": "awsui_m-xxxl_18wu0_nrld8_742",
  "m-top-xxxl": "awsui_m-top-xxxl_18wu0_nrld8_747",
  "m-vertical-xxxl": "awsui_m-vertical-xxxl_18wu0_nrld8_748",
  "m-right-xxxl": "awsui_m-right-xxxl_18wu0_nrld8_752",
  "m-horizontal-xxxl": "awsui_m-horizontal-xxxl_18wu0_nrld8_753",
  "m-bottom-xxxl": "awsui_m-bottom-xxxl_18wu0_nrld8_757",
  "m-left-xxxl": "awsui_m-left-xxxl_18wu0_nrld8_762",
  "d-block": "awsui_d-block_18wu0_nrld8_767",
  "d-inline": "awsui_d-inline_18wu0_nrld8_770",
  "d-inline-block": "awsui_d-inline-block_18wu0_nrld8_773",
  "d-none": "awsui_d-none_18wu0_nrld8_776",
  "f-left": "awsui_f-left_18wu0_nrld8_780",
  "f-right": "awsui_f-right_18wu0_nrld8_784",
  "visual-accent": "awsui_visual-accent_18wu0_nrld8_788",
  "visual-accent-radius-xxxs": "awsui_visual-accent-radius-xxxs_18wu0_nrld8_797",
  "visual-accent-radius-xxs": "awsui_visual-accent-radius-xxs_18wu0_nrld8_804",
  "visual-accent-radius-xs": "awsui_visual-accent-radius-xs_18wu0_nrld8_811",
  "visual-accent-radius-s": "awsui_visual-accent-radius-s_18wu0_nrld8_818",
  "visual-accent-radius-m": "awsui_visual-accent-radius-m_18wu0_nrld8_825",
  "visual-accent-radius-l": "awsui_visual-accent-radius-l_18wu0_nrld8_832",
  "visual-accent-radius-xl": "awsui_visual-accent-radius-xl_18wu0_nrld8_839",
  "visual-accent-radius-xxl": "awsui_visual-accent-radius-xxl_18wu0_nrld8_846",
  "visual-accent-radius-xxxl": "awsui_visual-accent-radius-xxxl_18wu0_nrld8_853",
  "visual-accent-radius-full": "awsui_visual-accent-radius-full_18wu0_nrld8_860",
  "visual-accent-aspect-auto": "awsui_visual-accent-aspect-auto_18wu0_nrld8_867",
  "visual-accent-aspect-equal": "awsui_visual-accent-aspect-equal_18wu0_nrld8_872",
  "visual-accent-red": "awsui_visual-accent-red_18wu0_nrld8_880",
  "visual-accent-yellow": "awsui_visual-accent-yellow_18wu0_nrld8_885",
  "visual-accent-indigo": "awsui_visual-accent-indigo_18wu0_nrld8_890",
  "visual-accent-green": "awsui_visual-accent-green_18wu0_nrld8_895",
  "visual-accent-orange": "awsui_visual-accent-orange_18wu0_nrld8_900",
  "visual-accent-purple": "awsui_visual-accent-purple_18wu0_nrld8_905",
  "visual-accent-grey": "awsui_visual-accent-grey_18wu0_nrld8_910",
  "visual-accent-teal": "awsui_visual-accent-teal_18wu0_nrld8_915",
  "root": "awsui_root_18wu0_nrld8_920"
};
  